import { axios } from "../config/axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";

// Runtime frontend configuration that must not ship inside the static JS
// bundle (the bundle is downloadable by anyone, pre-auth).
export const getMapsApiKey = async (): Promise<IAxiosResponse<string>> => {
  return axios.get("v2/Config/MapsKey");
};
